var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiuctchng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 24L1 0L5.96046e-08 0L5.96046e-08 24H1Z",
    fill: "#383838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7V2L9 2V7L0 7ZM0.831593 2.88825V6.09741L8.16841 6.09741V2.88825L0.831593 2.88825Z",
    fill: "#383838"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14V9H13V14H0ZM0.824122 9.88839V13.1118H12.1626V9.88839H0.824122Z",
    fill: "#383838"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21V16H18V21H0ZM0.834698 16.8882V20.1118H17.1653V16.8882H0.834698Z",
    fill: "#383838"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 21V16H9V21H10Z",
    fill: "#383838"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14V9H7V14H8Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiuctchng);
export default __webpack_public_path__ + "static/media/biểu đồ cột chồng.dca7dc59bc33937fa2dda7338063b8a0.svg";
export { ForwardRef as ReactComponent };